import authConfig from '~/app/config/auth'

const initializeAppConfig = () => {
  authConfig()
}

export default initializeAppConfig
